import { Injectable } from '@angular/core';
import { ObjectCacheService } from './icache-service';
import { ParamMap } from '../data-service/system-param-cache-define';
import { ParameterApi } from '../api-service/parameters/parameter-api';
import { EasyNotificationService } from '../easy-notification.service';
import { GpParaApi } from '../api-service/gp-para/gp-para-api';
import { NhiimiSetting } from 'src/app/system/clinic/models/nhiimiSetting';
import { ClinicApi } from '../api-service/clinic/clinic-api';
import { UserCache } from '../user-cache';
import { SpecialSameTreatDto, SpecialSameTreatRxDto } from '../api-service/val-addapp/special-sameTreat-dto';
import { TemporaryWorkApi } from '../api-service/val-addapp/temporaryWork-api';
import { PricingApi } from '../api-service/pricing/pricing-api';
import { PaymentApi } from '../api-service/payment/payment-api';
import { DiscountPriorityApi } from '../api-service/payment/discount-priority-api';
import { DiscountPriorityDto } from '../api-service/register/discount-priority-dto';
import { DoctorScheduleDto, ScheduleApi } from '../api-service/schedule/schedule-api';
import { RegisterApi } from '../api-service/register/register-api';

@Injectable({
  providedIn: 'root'
})

/**
 * 班表快取Service。
 * @implements {ICacheService<ParamType, Map<ParamType, any>>}
 */
export class ScheduleCachedService extends ObjectCacheService<DoctorScheduleObject> {

  protected notifyMsgOnUpdated: string = '暫存內容已變更…';
  protected notifyMsgOnReload: string = '已重載暫存內容'
  /**
   * 建構子，初始化服務。
   * @param {ParameterApi} parameterApi - 用於獲取參數的 API 服務。
   * @param {EasyNotificationService} notifyService - 用於顯示通知的服務。
   */
  constructor( 
    private schApi:ScheduleApi,private regApi:RegisterApi,
    private notifyService: EasyNotificationService) {
    super(notifyService);
  }

  protected async getCacheObject<k extends string|number>(keys: k[]): Promise<Map<k, DoctorScheduleDto[]>> {
    var m:Map<k, DoctorScheduleDto[]> = new Map();
    for(let d of keys){
      var s = d.toString().split('_')
      if(s[0]=='D'){
        var ret = await this.schApi.GetScheduleByDay(new Date(s[1])) 
        m.set(d,ret);
      }else if(s[0]=='P'){
        //藥師
        var ret = await this.schApi.GetPharScheduleByDay(new Date(s[1])) 
        m.set(d,ret);
      }else if(s[0]=='R'){
        //物理治療等
        var r = await this.regApi.GetRehabitMedUesrs(new Date(s[1])) 
        var rSche = r.map(x=>{
          return {
            PositionCodes:[x.PositionCode],
            UserCID:x.CId,
            UserName:x.Name,
            Date:new Date(s[1]),
            TimeSec:x.TimeSec,DefaPharm:0,DeptCode:''  ,UserId:0,RoomCode:x.Account
          }
        })
        m.set(d,rSche);
      }
      
    }
    return m;
  }
}
declare type DoctorScheduleObject = {[key:string]:DoctorScheduleDto[]}
